// In-app browsers (WhatsApp, Facebook, Instagram) often block the microphone.
// Detect them and offer the real browser.

export function inAppBrowser(ua = navigator.userAgent): 'whatsapp' | 'social' | null {
  if (/WhatsApp/i.test(ua)) return 'whatsapp';
  if (/FBAN|FBAV|Instagram|Line\//i.test(ua)) return 'social';
  return null;
}

export const isAndroid = (ua = navigator.userAgent) => /Android/i.test(ua);
// iPadOS reports a desktop Mac user agent; touch support separates it from a real Mac.
export const isIOS = (ua = navigator.userAgent, touchPoints = typeof navigator === 'undefined' ? 0 : navigator.maxTouchPoints ?? 0) =>
  /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/.test(ua) && touchPoints > 1);

/** Every iOS browser runs on WebKit, but the microphone switch sits under a different app in Settings. */
export function iosBrowser(ua = navigator.userAgent, touchPoints?: number): 'chrome' | 'firefox' | 'edge' | 'safari' | null {
  if (!isIOS(ua, touchPoints)) return null;
  if (/CriOS/.test(ua)) return 'chrome';
  if (/FxiOS/.test(ua)) return 'firefox';
  if (/EdgiOS/.test(ua)) return 'edge';
  return 'safari';
}

/** Android: an intent URL opens the same page in Chrome. */
export function chromeIntent(href = location.href): string {
  const u = new URL(href);
  return `intent://${u.host}${u.pathname}${u.search}#Intent;scheme=https;package=com.android.chrome;end`;
}
